import React from 'react';
import { Users, ShoppingBag, Trophy, MessageSquare, MessageCircle, ArrowRight } from 'lucide-react';

export const WhatsAppCommunitySection = () => (
  <div className="relative mt-12 overflow-hidden rounded-3xl shadow-2xl" data-testid="whatsapp-community-section">
    <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-emerald-50 to-white"></div>
    <div className="absolute -top-32 -left-32 w-96 h-96 bg-emerald-300/30 rounded-full blur-3xl"></div>
    <div className="absolute -bottom-32 -right-32 w-96 h-96 bg-blue-300/30 rounded-full blur-3xl"></div>

    <div className="relative z-10 p-8 md:p-12">
      <div className="text-center mb-8">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-gradient-to-r from-emerald-500 to-teal-500 text-white text-sm font-bold shadow-lg mb-4">
          <MessageCircle className="w-4 h-4" />
          הצטרפו לקהילה
        </div>
        <h2 className="text-4xl md:text-5xl font-black text-slate-900 leading-tight mb-3">
          <span>קהילת הטניס </span>
          <span className="bg-gradient-to-r from-emerald-600 to-blue-600 bg-clip-text text-transparent">בוואטסאפ</span>
        </h2>
        <p className="text-lg text-slate-600">
          4 קבוצות פעילות לתיאום משחקים, ציוד, תחרויות ושיחות טניס
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-4xl mx-auto">
        {[
          { name: 'תיאום משחקים', desc: 'מצא שותפים לאימון לפי רמות', icon: Users, gradient: 'from-blue-500 to-cyan-500', link: 'https://chat.whatsapp.com/G8bFY7cDuexKCfihNknRyY', emoji: '🎾' },
          { name: 'ציוד טניס', desc: 'קנייה ומכירה - חדש ויד שנייה', icon: ShoppingBag, gradient: 'from-emerald-500 to-teal-500', link: 'https://chat.whatsapp.com/KWlfpYYJu7kJHXS5eMH1cR', emoji: '🛒' },
          { name: 'תחרויות ועדכונים', desc: 'עדכונים שוטפים על תחרויות', icon: Trophy, gradient: 'from-amber-500 to-orange-500', link: 'https://chat.whatsapp.com/B7xnF1EjblnAbv5ixZ9kuo', emoji: '🏆' },
          { name: 'פורום טניס', desc: 'שיחות, טיפים ושאלות כלליות', icon: MessageSquare, gradient: 'from-purple-500 to-indigo-500', link: 'https://chat.whatsapp.com/GlsP2SWG4PI4r034BSH6kE', emoji: '💬' },
        ].map((g) => (
          <a
            key={g.name}
            href={g.link}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`wa-card-${g.name}`}
            className="group relative bg-white rounded-2xl p-5 shadow-lg border border-slate-100 hover:shadow-2xl hover:-translate-y-1 transition-all overflow-hidden"
          >
            <div className={`absolute -top-10 -right-10 w-32 h-32 bg-gradient-to-br ${g.gradient} rounded-full blur-2xl opacity-20 group-hover:opacity-40 transition-opacity`}></div>
            <div className="relative flex items-center gap-4">
              <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${g.gradient} flex items-center justify-center shadow-lg shrink-0`}>
                <g.icon className="w-7 h-7 text-white" />
              </div>
              <div className="flex-1 text-right">
                <div className="flex items-center justify-between gap-2 mb-1">
                  <span className="text-2xl">{g.emoji}</span>
                  <h3 className="text-lg font-black text-slate-900">{g.name}</h3>
                </div>
                <p className="text-sm text-slate-600">{g.desc}</p>
              </div>
            </div>
            <div className="relative mt-4 flex items-center justify-end gap-1 text-sm font-semibold text-emerald-600 group-hover:text-emerald-700">
              <span>הצטרף לקבוצה</span>
              <ArrowRight className="w-4 h-4" />
            </div>
          </a>
        ))}
      </div>
    </div>
  </div>
);
